import { Navigate, Outlet } from 'react-router-dom';
import { UserContext} from "../context/authContext"
import React, { useContext } from 'react';
 

export const ProtectedRoute = (): any => {
  // const [storedToken, setStoredToken] = useLocalStorage<string>(
  //   'myKey',
  //   'initialValue'
  // );
  const { token } = useContext(UserContext);
  // console.log("hitting protecetd route ", token)
  if (!token) {
    //user is not authenticated
    return <Navigate to="/login" />;
  }
  return (
    <>
    <Outlet />
    </>
  )
};
